import React from 'react';
import CustomTable from './CustomTable';

const ProductMapping = () => {
  
  return (
    <section className="main-container col1-layout">
      <div className="main">
        <div className="col-main">
          <div className="shopping-cart-inner">
            <div className="page-content">
              <div className="page-content checkout-page">
 
                {/* <div className="box-border" style={{ margin: "auto", maxWidth: "80%" }}> */}
                <div className="box-border">

                  {/* <div className="order-detail-content table-responsive" style={{width:"auto"}}> */}
                  
                  <CustomTable globalSearch={false}/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    </section >
  );
};

export default ProductMapping;
